import { type TypedUseSelectorHook, useDispatch, useSelector } from "react-redux";
import type { IAppDispatch, IRootState } from "@/redux/store";

export const useAppDispatch: () => IAppDispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<IRootState> = useSelector;